import PortofolioProject from "../components/PortofolioProject";

const Portofolio = () => {
  return (
    <div className="portofolio">
      <h1>Projects</h1>
      <h2>Android</h2>
      <PortofolioProject category={"android"} />
    </div>
  );
};

export default Portofolio;
